import axios from 'axios';


const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
})

export class ReservationsFetchAPI  {

        static async createReservation (payload, token) {
            const res = await server(`/reservations`, {
                method: "POST",
                headers: token ? { 'x-access-token': token } : undefined,
                data: payload
            });
            return res 
        }

    
}